import { hasPluginPermission } from "imports/Utils";
import "./styling.scss";
import { useStoreState } from "ezStore";
import { Voyage, Ship } from "types/index";
import LastShippedProductsFreeText from "components/products/LastShippedProductsFreeText";
import LastShippedProductsMasterdata from "components/products/LastShippedProductsMasterData";
import { LabelPlacement } from "@cofano/cck";

export type LastShippedProductsProps = {
	voyage?: Pick<Voyage, "id" | "lastShippedProductsFreeText" | "lastShippedProducts">;
	ship?: Pick<Ship, "id" | "bargeType" | "tanks" | "lastShippedProducts">;
	refetch: () => void;
	charterId?: number;
	labelPlacement?: LabelPlacement;
	forceReadOnly?: boolean;
};

const LastShippedProducts = ({ voyage, ship, refetch, charterId, labelPlacement = "left-center", forceReadOnly }: LastShippedProductsProps) => {

	const session = useStoreState(store => store.session);
	const useFreeText = hasPluginPermission(session, "lastShippedProductsAsFreeText");

	if (useFreeText) {
		return <LastShippedProductsFreeText
			voyage={voyage}
			labelPlacement={labelPlacement}
			ship={ship}
			refetch={refetch}
			charterId={charterId}
			forceReadOnly={forceReadOnly}
		/>;
	} else {
		return (
			<LastShippedProductsMasterdata
				voyage={voyage}
				ship={ship}
				refetch={refetch}
				forceReadOnly={forceReadOnly}
			/>
		);
	}
};

export default LastShippedProducts;
